/**
 * Regra única de elegibilidade para "apagar mensagem", compartilhada pelo chat
 * web e pelo mobile para não duplicar o critério em dois lugares.
 */

/**
 * O WhatsApp permite "apagar para todos" em até 60 horas após o envio. Usamos
 * uma margem de segurança porque mensagens exatamente no limite podem ser
 * aceitas pela API e ainda assim ignoradas pelo aparelho do destinatário — o
 * que faria o sistema exibir um tombstone sem que a mensagem tenha sumido de
 * fato. A edge function delete-message-v3 revalida com as 60h cheias.
 */
export const DELETE_WINDOW_HOURS = 59
const DELETE_WINDOW_MS = DELETE_WINDOW_HOURS * 60 * 60 * 1000

export interface DeletableMessage {
  from_me?: boolean
  wa_message_id?: string | null
  sent_at?: string | null
  deleted_at?: string | null
  isOptimistic?: boolean
}

export function isMessageDeleted(message: DeletableMessage): boolean {
  return Boolean(message.deleted_at)
}

export function canDeleteMessage(message: DeletableMessage): boolean {
  if (message.from_me !== true) return false
  if (message.isOptimistic) return false
  if (isMessageDeleted(message)) return false

  const waMessageId = message.wa_message_id
  if (!waMessageId || waMessageId.startsWith('optimistic_')) return false

  const sentAtMs = message.sent_at ? Date.parse(message.sent_at) : NaN
  if (!Number.isFinite(sentAtMs)) return false

  return Date.now() - sentAtMs < DELETE_WINDOW_MS
}
